import { ADMIN_ROLES, VENDOR_ROLES } from "constants/user"

export const getScope = (role: string) => {
    if(ADMIN_ROLES.includes(role)){
        return 'system';
    }else if(VENDOR_ROLES.includes(role)){
        return 'vendor';
    }else {
        return 'business unit'
    }
}